import {PIN_ZOOM,pinGrowth,pinTranslation} from './map-geometry.mjs';
// Rectangle/triangle SAT includes the pin tip, not just its circular head.
function triangleOverlapsRect(triangle,rect) {
  const box=[[rect[0],rect[1]],[rect[2],rect[1]],[rect[2],rect[3]],[rect[0],rect[3]]];
  const axes=[[1,0],[0,1],...triangle.map((p,i)=>{const q=triangle[(i+1)%3];return [p[1]-q[1],q[0]-p[0]];})];
  return axes.every(([x,y])=>{const a=triangle.map(p=>p[0]*x+p[1]*y),b=box.map(p=>p[0]*x+p[1]*y);return Math.max(...a)>=Math.min(...b)&&Math.max(...b)>=Math.min(...a);});
}
// Head and badge bounds use the same scale as sprites and fine-pointer hit testing.
export function collidingBadges(features,map,selectedId=null,selectedScale=1.5) {
  const zoom=map.getZoom?.()??15;
  for(const f of features)delete f.properties.hideBadge;
  const pins=features.filter(f=>f.properties.rank||f.properties.id===selectedId||zoom>=PIN_ZOOM).map(f=>{
    const selected=f.properties.id===selectedId?selectedScale:1,full=selected>1||f.properties.rank;
    const growth=full?1:pinGrowth(zoom),p=map.project(f.geometry.coordinates);
    return {f,p:{x:p.x,y:p.y+(full?0:pinTranslation(zoom))},scale:(f.properties.pinScale||1)*selected*growth,badgeScale:selected*growth};
  });
  // Broad phase: index each head/tip envelope, not every pin against every badge.
  // The exact circle/SAT tests below retain the existing selected-pin geometry.
  const cells=new Map(),cellSize=64;
  function visit(rect,callback) {
    for(let x=Math.floor(rect[0]/cellSize);x<=Math.floor(rect[2]/cellSize);x++)
      for(let y=Math.floor(rect[1]/cellSize);y<=Math.floor(rect[3]/cellSize);y++)callback(`${x},${y}`);
  }
  for(const pin of pins){const {p,scale:s}=pin;visit([p.x-19*s,p.y-50*s,p.x+19*s,p.y+s],key=>{
    if(!cells.has(key))cells.set(key,[]);cells.get(key).push(pin);
  });}
  for(const {f,p,scale,badgeScale} of pins){const w=f.properties.pinBadgeWidth*badgeScale;if(!w)continue;
    const rect=[p.x-w/2,p.y+4*scale,p.x+w/2,p.y+23*scale];
    const candidates=new Set();visit(rect,key=>{for(const pin of cells.get(key)||[])candidates.add(pin);});
    if([...candidates].some(other=>{
      if(other.f===f)return false;
      const {p:q,scale:s}=other,dx=q.x-Math.max(rect[0],Math.min(q.x,rect[2])),y=q.y-31*s,dy=y-Math.max(rect[1],Math.min(y,rect[3]));
      return dx*dx+dy*dy<(19*s)**2 || triangleOverlapsRect([[q.x-16*s,q.y-20*s],[q.x+16*s,q.y-20*s],[q.x,q.y]],rect);
    }))f.properties.hideBadge=true;
  }
}
